import React, { useState } from "react"
import "components/style.scss"
import { withRouter } from "react-router-dom"

import { URL_PATHS } from "constants/index"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Popover,
} from "reactstrap"

const MpAdmisDropdown = props => {
  const [adminsButtonToggle, setAdminsButtonToggle] = useState(false)
  const [adminRoleManagementToggle, setAdminRoleManagementToggle] =
    useState(false)

  return (
    <Dropdown
      isOpen={adminsButtonToggle}
      toggle={() => {
        setAdminsButtonToggle(!adminsButtonToggle)
        if (adminsButtonToggle) {
          setAdminRoleManagementToggle(false)
        }
      }}
      className="ms-3"
    >
      <DropdownToggle caret color="light">
        MP ADMINS
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => props.history.push(URL_PATHS.CLIENTS)}>
          Clients
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            setAdminRoleManagementToggle(!adminRoleManagementToggle)
          }}
          toggle={false}
          id="admin_management_dropdown_btn"
        >
          <div className="d-flex" style={{ justifyContent: "space-between" }}>
            <span>Admin Role Management</span>
            <i className="bx bx-chevron-right d-none d-xl-inline-block  font-size-18" />
          </div>
          <Popover
            isOpen={adminRoleManagementToggle}
            target="admin_management_dropdown_btn"
            placement="right"
          >
            <DropdownMenu>
              <DropdownItem
                onClick={() =>
                  props.history.push(URL_PATHS.ADMIN_ROLES_MANAGEMENT)
                }
              >
                Admin Roles
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  props.history.push(URL_PATHS.PERMISSIONS_MANAGEMENT)
                }
              >
                Permissions
              </DropdownItem>
            </DropdownMenu>
          </Popover>
        </DropdownItem>
        <DropdownItem onClick={() => props.history.push(URL_PATHS.SITE_USERS)}>
          Clients' end-users
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}

export default withRouter(MpAdmisDropdown)
